import {
  Center,
  Flex,
  Text,
  TypographyStylesProvider,
  useMantineTheme,
} from "@mantine/core";
import {
  AccordionDescriptions,
  AccordionDoubts,
  Breadcrumb,
  BrokersCardsNew,
  BuyArea,
  InstrumentsNew,
  Modal,
  ModalLoading,
} from "../../components";
import { useNavigate, useParams } from "react-router-dom";
import { useProduct } from "../../hooks/useProduct";
import { useMediaQuery } from "@mantine/hooks";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { ESubcategoryType } from "../../interfaces/Products/IProductDetail";
import HeaderItem from "./HeaderItem";
import { DocumentText, PresentionChart } from "iconsax-react";
import PerformanceChart from "./PerformanceChart";
import ParametersProduct from "./ParametersProduct";
import ButtonCallToAction from "./ButtonCallToAction";
import AccordionDescriptionsItem from "../../components/Accordion/AccordionDescriptions/AccordionItem";

const ProductDetail = () => {
  const { t } = useTranslation();
  const theme = useMantineTheme();
  const navigate = useNavigate();
  const { slug } = useParams();
  const id = slug?.split("&id=")[1];
  const idArray = id ? [Number(id)] : [];
  const isLargerThan991 = useMediaQuery("(min-width: 991px)");
  const [isSuccess, setIsSuccess] = useState(false);
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [isOpenModalError, setIsOpenModalError] = useState<string>("");
  const [accordionValue, setAccordionValue] = useState<string[]>([
    "Description",
    "Doubts",
  ]);

  const { data, isLoading } = useProduct({
    productId: idArray,
  });

  const PRODUCT_QUESTIONS =
    data?.product?.faq.map((question) => ({
      id: String(question.id),
      title: question.question,
      content: question.answer,
    })) ?? [];

  const navlinks = [
    { title: t("marketplace.title"), href: "/marketplace" },
    { title: t("marketplace.detalhe.title"), href: "#" },
  ];
  const handleSucessConfirmationClose = () => {
    setIsLoadingModal(false);
    setIsSuccess(false);
  };

  const handleRedirect = () => {
    navigate("/meu-portfolio/minhas-compras");
  };

  const handleCloseErrorModal = () => {
    setIsOpenModalError("");
  };

  const showGraphic =
    data?.product?.subcategory === ESubcategoryType.wallets ||
    data?.product?.subcategory === ESubcategoryType.daytrade ||
    data?.product?.subcategory === ESubcategoryType.swingtrade;
  // if (isError && isFetched && !data) return <PageNotFound />;
  return (
    <Center
      px={{ base: 24, xl: 20 }}
      mb="32px"
      pos="relative"
      sx={{
        ":before": {
          position: "absolute",
          zIndex: -1,
          top: "0",
          right: "0",
          background: theme.colors.other[3],
          content: "''",
          height: "300px",
          width: "100vw",
        },
      }}
    >
      {isLoadingModal ? (
        <ModalLoading open={isLoadingModal} />
      ) : (
        <Modal
          type={"success"}
          titleFirstButton={t(
            "marketplace.comprar_serviços.modal_success.title_first_button"
          )}
          titleSeccondButton={t("global.button.close")}
          description={t(
            "marketplace.comprar_serviços.modal_success.description"
          )}
          open={isSuccess}
          setClose={handleSucessConfirmationClose}
          secondClick={handleSucessConfirmationClose}
          firstClick={handleRedirect}
        />
      )}

      <Modal
        type={"danger"}
        titleFirstButton={t("global.button.close")}
        description={isOpenModalError}
        contentEspecial={
          <Text c="basic.4" fz="16px" lh="155%" ta={"center"} mb="32px">
            {t("marketplace.comprar_serviços.modal_danger.content_especial")}
          </Text>
        }
        textModal={t("marketplace.comprar_serviços.modal_danger.text_modal")}
        open={!!isOpenModalError}
        setClose={handleCloseErrorModal}
        firstClick={handleCloseErrorModal}
      />

      <Flex
        pt="32px"
        direction="column"
        maw={1680}
        w="100%"
        gap={{ base: "24px", 991: "48px" }}
      >
        <Breadcrumb navlinks={navlinks} />

        <Flex
          direction="column"
          gap="24px"
          w="100%"
          p={{ base: "24px", 1500: "48px" }}
          bg={theme.colors.basic[0]}
          style={{
            boxShadow: "0px 25px 35px rgba(0, 0, 0, 0.03)",
            borderRadius: "12px",
          }}
        >
          <Flex
            gap="16px"
            w="100%"
            direction="column"
            p="16px"
            bg={theme.colors.basic[0]}
            style={{
              border: "1px solid",
              borderColor: theme.colors.basic[2],
              borderRadius: isLargerThan991 ? "12px" : "16px",
            }}
          >
            <Flex
              w="100%"
              gap="20px"
              justify={"space-between"}
              wrap={{ base: "wrap", 1300: "nowrap" }}
            >
              <HeaderItem product={data?.product} isLoading={isLoading} />

              <InstrumentsNew product={data?.product} />

              <BrokersCardsNew product={data?.product} />
            </Flex>
            <ParametersProduct selectedProduct={data} />
            {/* <ButtonAssign selectedProduct={data} /> */}

            <BuyArea selectedProduct={data} isLoading={isLoading} />
          </Flex>

          <AccordionDescriptions
            accordionValue={accordionValue}
            setAccordionValue={setAccordionValue}
          >
            {showGraphic ? (
              <PerformanceChart initialDate={data?.product?.created_at} />
            ) : null}
            <AccordionDescriptionsItem
              value="Description"
              Icon={DocumentText}
              Panel={
                <>
                  <TypographyStylesProvider style={{}}>
                    <Text
                      ff="barlow"
                      lh="32px"
                      color="basic.4"
                      dangerouslySetInnerHTML={{
                        __html: data?.product.detailed_description || "",
                      }}
                    />
                  </TypographyStylesProvider>
                  <ButtonCallToAction selectedProduct={data} />
                </>
              }
              title={t("marketplace.detalhe.description_service.title")}
            />
            <AccordionDescriptionsItem
              value="Doubts"
              Icon={PresentionChart}
              Panel={
                PRODUCT_QUESTIONS.length > 0 ? (
                  <Flex
                    direction="column"
                    gap="24px"
                    w="100%"
                    p={{ base: "20px", 991: "0px" }}
                    bg={theme.colors.basic[0]}
                    style={{
                      boxShadow: isLargerThan991
                        ? "none"
                        : "0px 25px 35px rgba(0, 0, 0, 0.03)",
                      borderRadius: isLargerThan991 ? "none" : "12px",
                    }}
                  >
                    <AccordionDoubts data={PRODUCT_QUESTIONS} />
                  </Flex>
                ) : null
              }
              title={t("marketplace.detalhe.doubt_general.title")}
            />
          </AccordionDescriptions>
        </Flex>
      </Flex>
    </Center>
  );
};

export default ProductDetail;
